import { RootState } from '@atredux/store'
import { IInterruptData } from '@atredux/slices/interruptSlice'

export const getInterruptData = (state: RootState): IInterruptData =>
    state.interrupt._interruptData
export const getInterruptOpen = (state: RootState): boolean => {
    return state.interrupt._interruptOpen
}
